module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACiSURBVHgB7ZNbEcIwFETvjQIkRAISMJCHAyoFFCABJNAYABzgoFWSdNPms490Jh/9yM7c7M/OyWM2RJmy1sqcnMgJaa0fIYROKdUUATLzObksAtyjCjwgkONijHnC5Eou1uaE6dPMynvfcvwBsbRURv/xhIA2oMulFAp9pekGX2z+W8oJId5MGcKTfGAXwO7OudtatvawApPQwxbWo2evrewA7lwpklKG0jwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/add-icon-checked.png
// module id = 311
// module chunks = 1